export default function({ app }) {
	app.router.beforeEach((to, from, next) => {
		app.router.previousRoute = from;
		next();
	});
}